import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { DialogAddInvoiceComponent } from '../../renditions/dialog-add-invoice/dialog-add-invoice.component';

@Component({
  selector: 'qr-dialog-full-screen',
  templateUrl: './dialog-full-screen.component.html',
  styleUrls: ['./dialog-full-screen.component.scss'],
})
export class DialogFullScreenComponent {
  @Input() config!: QRDialog;
  valueChange: any;
  @Output() dialogChange: EventEmitter<any> = new EventEmitter<any>();
  changeSubscription: Subscription | undefined;

  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };

  tempScrollTop: number | undefined;

  buttonAction: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Botón',
  };

  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Botón',
  };

  // Componente dinamico
  @ViewChild('dinamicContainer', { read: ViewContainerRef })
  target!: ViewContainerRef;
  private componentRef!: ComponentRef<any>;

  // Eventos de teclado
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == 'Escape' && this.config.isVisible) {
      // Tecla ESC: Cierra Diálogo
      this.close();
    }
  }

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config']) {
      this.buttonAction.viewValue = this.config.textButtonAction;
      this.buttonCancel.viewValue = this.config.textButtonCancel;

      if (this.config.isVisible) {
        // Esto logra que no se mueva el scroll del body al estar scrolleando el diálogo
        this.tempScrollTop = window.pageYOffset;
        document.body.classList.add('disable-scroll');
        document.body.style.top = '-' + this.tempScrollTop + 'px';
        this.addComponentDynamically();
      }
    }
  }

  action(): void {
    if (this.config.componentToLoad != DialogAddInvoiceComponent)
      this.dialogChange.emit(this.valueChange);
    this.close();
  }

  close(): void {
    this.config.isVisible = false;
    // Se habilita nuevamente el scroll del body y se lleva al scroll original
    document.body.classList.remove('ng-scope', 'disable-scroll');
    document.body.style.top = '0px';
    window.scrollTo({ top: this.tempScrollTop });

    if (this.config.componentToLoad == DialogAddInvoiceComponent)
      this.dialogChange.emit(this.valueChange);
  }

  /*
	addComponentDynamically: Agregar un componente de forma dinámica
	*/
  addComponentDynamically() {
    this.cdRef.detectChanges(); // run change detection immediately
    if (this.target) {
      this.target.clear(); // Limpiar contenedor de componentes dinámicos
      this.componentRef = this.target.createComponent(
        this.config.componentToLoad
      );
    }
    if (this.componentRef) {
      // Enviar al componente dinámico datos
      this.componentRef.instance.value = this.config.value;
      // Escuchar @Output del componente dinámico
      if (this.componentRef.instance.change) {
        this.changeSubscription = this.componentRef.instance.change.subscribe(
          (value: any) => {
            if (value) {
              this.valueChange = value;
            }
          }
        );
      }
    }
  }

  getContentHeight(): string {
    let height: string;
    if (this.config.textButtonAction || this.config.textButtonCancel) {
      height = 'calc(100vh - 72px - 72px)'; // con botbar
    } else {
      height = 'calc(100vh - 72px)';
    }
    return height;
  }
}
